// extracted by mini-css-extract-plugin
module.exports = {"cookieConsent":"styles_cookieConsent__2OlNa"};